






































import { Component } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import TimeTask from '@/api/goods/timeTask/index'
import GoodSelect from '@/components/goods-select/index.vue'

@Component({
  components: {
    GoodSelect,
  },
})
export default class EditPriceManagement extends AbpBase {
  form = {
    begin: null,
    end: null,
    resetPrice: false,
    taskState: 0,
    productTimeTaskMapping: [],
  }
  taskStateList: any[] = [
    {
      label: '未开始',
      value: 0,
    },
    {
      label: '运行中',
      value: 1,
    },
    {
      label: '已完成',
      value: 2,
    },
  ]
  columns = [
    {
      title: '商品编号',
      key: 'productCode',
    },
    {
      title: '商品名称',
      key: 'productName',
    },
    {
      title: '商品价格',
      key: 'price',
    },
    {
      title: '商品原价',
      key: 'resetPrice',
    },
    // {
    //   title: '图片',
    //   key: 'pictureUrl',
    //   slot: 'pictureUrl',
    // },
    // {
    //   title: '款号',
    //   key: 'productCode',
    // },
    {
      title: '操作',
      key: 'action',
      slot: 'action',
    },
  ]
  ruleForm = {
    begin: [{ required: true, type: 'date', message: '请输入开始时间', trigger: 'change' }],
    end: [{ required: true, type: 'date', message: '请输入结束时间', trigger: 'change' }],
  }

  created() {
    this.getTimetaskDetail()
  }

  /**
   * 获取定时任务详情
   */
  getTimetaskDetail() {
    let id = this.$route.query['id']
    if (id) {
      TimeTask.getTimeTaskDetail(id.toString()).then((res) => {
        res.data.begin = new Date(res.data.begin)
        res.data.end = new Date(res.data.end)
        console.log(res.data)
        this.form = res.data
      })
    }
  }
  deleteItem(productIndex) {
    this.form.productTimeTaskMapping.splice(productIndex, 1)
  }
  onProductChange(e) {
    console.log('e: ', e)
    let { id } = this.$route.params
    this.form.productTimeTaskMapping = e
    // e.forEach((t) => {
    //   this.form.productTimeTaskMapping.push({
    //     taskId: id ? id : '',
    //     productId: t.productId,
    //     pictureUrl: t.pictureUrl,
    //     productName: t.productName,
    //     price: t.price,
    //   })
    // })
  }
  submit() {
    let vm = this
    let form: any = vm.$refs.form
    form.validate((valid) => {
      if (valid) {
        let id = vm.$route.query['id'] ? vm.$route.query['id'].toString() : null
        // let copyForm = JSON.parse(JSON.stringify(vm.form))
        // copyForm.begin = new Date(vm.form.begin)
        // copyForm.end = new Date(vm.form.end)
        if (id) {
          TimeTask.updateTimeTaskDetail(id, vm.form).then((res) => {
            vm.$Notice.success({
              desc: '修改成功',
            })
            vm.$router.replace({
              name: 'priceManagement',
            })
          })
        } else {
          TimeTask.postTimeTask(vm.form).then((res) => {
            vm.$Notice.success({
              desc: '创建成功',
            })
            vm.$router.replace({
              name: 'priceManagement',
            })
          })
        }
      }
    })
  }
}
